import React, { PureComponent } from 'react';

import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { object } from '@philips-emr/tws-core/lib/component/prop-types';
import './hpms-indice-reajuste-ds-documentacao.scss';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
export default class HpmsIndiceReajusteDsDocumentacao extends PureComponent {

  static propTypes = {
    data: object,
  }

  getDsDocumentacao = () => {
    const { data } = this.props;
    return data && data.dsDocumentacao;
  }

  onCheck() {
    this.setState({ check: !this.state.check });
  }

  render() {
    return (
      <div className="c-indice-reajuste-ds-documentacao">
        <div className="c-indice-reajuste-ds-documentacao__value--break-wrap-text" dangerouslySetInnerHTML={{ __html: this.getDsDocumentacao() }}></div>
      </div>
    );
  }
}
